/* eslint-disable no-param-reassign */
/**
 * Standardize address returned from Parky, which uses the V2 version of BigC
 * address API, into the schema defined in csc-checkout, common/address.json
 * https://developer.bigcommerce.com/api-reference/store-management/customers-v2/customer-addresses/getallcustomeraddresses
 */

import type { BCAddressType } from '@/types/BigCommerce/BCAddresses'
import type { StandardAddress } from '@/types/ShopFront/CheckoutStandards'

const swapAndDeleteProp = (obj = {}, a, b) => {
  if (obj[a] !== undefined) {
    [obj[a], obj[b]] = [obj[b], obj[a]] // Swap values
    delete obj[a]
  }
}

export type StandardToBCAddress = (address: StandardAddress) => BCAddressType

export const standardizeAddressForBigC: StandardToBCAddress = (address) => {
  swapAndDeleteProp(address, 'street1', 'address1')
  swapAndDeleteProp(address, 'street2', 'address2')
  swapAndDeleteProp(address, 'stateAcronym', 'stateOrProvinceCode')
  swapAndDeleteProp(address, 'zip', 'postalCode')
  swapAndDeleteProp(address, 'stateName', 'stateOrProvince')
  return JSON.parse(JSON.stringify({
    ...address,
    country: 'United States',
    countryCode: 'US',
    shouldSaveAddress: false,
  }))
}
